// ─── Photo utilities ──────────────────────────────────────────────────────────
export const photoDims = new Map();

export function fixImageRotation(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => {
      const img = new Image();
      img.onload = () => {
        const MAX = 1024;   // plenty for defect photos; keeps PDFs small
        let w = img.naturalWidth;
        let h = img.naturalHeight;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else        { w = Math.round(w * MAX / h); h = MAX; }
        }
        const canvas = document.createElement("canvas");
        canvas.width  = w;
        canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        const src = canvas.toDataURL("image/jpeg", 0.62);
        photoDims.set(src, { w, h });
        resolve(src);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}
